import apiClient from "./apiClient";
import {
  AdminLoginRequest,
  AdminTwoFactorCodeRequest,
} from "../models/RequestModels/AdminLoginRequest";
import {
  AdminAuthSuccessResponse,
  AdminLoginResponse,
  AdminTwoFactorSetupResponse,
} from "../models/ResponseModels/AdminLoginResponse";
import { AdminMeResponse } from "../models/ResponseModels/AdminMeResponse";
import { API_BASE_URL } from "../constants/ApiConfig";
import axios from "axios";

export const adminLoginRequest = async (
  body: AdminLoginRequest,
): Promise<AdminLoginResponse> => {
  const response = await apiClient.post<AdminLoginResponse>(
    "/admin/login",
    body,
  );

  return response.data;
};

const twoFactorClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Client-Source": "admin-panel",
  },
});

export const adminTwoFactorSetupRequest = async (
  setupToken: string,
): Promise<AdminTwoFactorSetupResponse> => {
  const response = await twoFactorClient.post<AdminTwoFactorSetupResponse>(
    "/admin/2fa/setup",
    {},
    {
      headers: {
        Authorization: `Bearer ${setupToken}`,
      },
    },
  );

  return response.data;
};

export const adminTwoFactorConfirmRequest = async (
  setupToken: string,
  body: AdminTwoFactorCodeRequest,
): Promise<AdminAuthSuccessResponse> => {
  const response = await twoFactorClient.post<AdminAuthSuccessResponse>(
    "/admin/2fa/confirm",
    body,
    {
      headers: {
        Authorization: `Bearer ${setupToken}`,
      },
    },
  );

  return response.data;
};

export const adminTwoFactorChallengeRequest = async (
  challengeToken: string,
  body: AdminTwoFactorCodeRequest,
): Promise<AdminAuthSuccessResponse> => {
  const response = await twoFactorClient.post<AdminAuthSuccessResponse>(
    "/admin/2fa/challenge",
    body,
    {
      headers: {
        Authorization: `Bearer ${challengeToken}`,
      },
    },
  );

  return response.data;
};

export const adminMeRequest = async (): Promise<AdminMeResponse> => {
  const response = await apiClient.get<AdminMeResponse>("/admin/me");

  return response.data;
};

export const adminLogoutRequest = async (): Promise<{ message: string }> => {
  const response = await apiClient.post<{ message: string }>("/admin/logout");

  return response.data;
};
